import { render } from "./ConfigValueSelector.vue?vue&type=template&id=4cd9d50a&ts=true"
import script from "./ConfigValueSelector.vue?vue&type=script&lang=ts"
export * from "./ConfigValueSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__